import Q = require('q');

import { BurndownConstants } from 'Widgets/Scripts/Burndown/BurndownConstants';
import { BurndownSettings, DateSampleMode, DateSampleInterval } from 'Widgets/Scripts/Burndown/BurndownSettings';
import { SettingsManagerBase } from 'Widgets/Scripts/ModernWidgetTypes/SettingsManagerBase';
import { AggregationMode } from 'Widgets/Scripts/ModernWidgetTypes/CommonConfigurationTypes';
import { getDefaultWebContext } from "VSS/Context";
import { TeamContext } from 'VSS/Common/Contracts/Platform';
import * as DateUtils from "VSS/Utils/Date";
import { DateSKParser } from "Analytics/Scripts/DateSKParser";
import { DayOfWeek } from "VSS/Common/Contracts/System";
import { WorkItemTypeFilterMode } from 'Widgets/Scripts/Shared/WorkItemTypePicker';

export default class BurndownSettingsManager extends SettingsManagerBase<BurndownSettings> {
    public getFeatureName(): string {
        return BurndownConstants.featureName;
    }

    /**
     * Performs neccessary legwork to produce default Burndown Settings, if possible.
     */
    public generateDefaultSettings(teamContext: TeamContext): IPromise<BurndownSettings> {
        return Q(this.packDefaultSettings(teamContext));
    }

    protected packDefaultSettings(teamContext: TeamContext): BurndownSettings {
        const endDate = new Date();
        const startDate = DateUtils.addDays(endDate, -14);

        let defaultSettings: BurndownSettings = {
            /** Spec required initial default values */
            includeBugsForRequirementCategory: false,
            burndownTrendlineEnabled: true,
            totalScopeTrendlineEnabled: true,
            completedWorkEnabled: false,
            stackByWorkItemTypeEnabled: false,
            aggregation: {
                identifier: AggregationMode.Count,
                settings: ""
            },
            workItemTypeFilter: {
                identifier: WorkItemTypeFilterMode[WorkItemTypeFilterMode.BacklogCategory],
                settings: "Microsoft.RequirementCategory"
            },
            timePeriodConfiguration: {
                startDate: DateUtils.format(startDate, DateSKParser.dateStringFormat),
                samplingConfiguration: {
                    identifier: DateSampleMode.ByDateInterval,
                    settings: {
                        endDate: DateUtils.format(endDate, DateSKParser.dateStringFormat),
                        lastDayOfWeek: DayOfWeek.Friday,
                        sampleInterval: DateSampleInterval.Days
                    },
                }
            },
            teams: [{
                projectId: getDefaultWebContext().project.id,
                teamId: teamContext.id
            }],
            fieldFilters: []
        } as any;

        return defaultSettings;
    }
}